































































import Vue from 'vue';
import { mapActions } from 'vuex';
import { get } from 'vuex-pathify';

import moment from 'moment';
import { Transition } from '@/models/transition';
import { ErrorManager } from '@/models/error';
import ErrorAlert from '../common/ErrorAlert.vue';
import RequestStatusDisplay from '../request-common/RequestStatusDisplay.vue';
import {
  IOvertimeRequest,
  IOvertimeRequestData,
  OvertimeRequest
} from '@/models';
import ALDialog from '../core/Dialog/ALDialog.vue';

export default Vue.extend({
  components: { ErrorAlert, RequestStatusDisplay, ALDialog },
  data: () => ({
    dialog: false,
    loading: false,

    errorMessage: '',
    detailErrorMessage: '',

    request: {} as IOvertimeRequestData,

    headers: [
      {
        text: 'Date',
        align: 'start',
        sortable: false,
        value: 'timestamp'
      },
      {
        text: 'Changed By',
        align: 'start',
        sortable: false,
        value: 'user'
      },
      {
        text: 'Previous State',
        align: 'center',
        sortable: false,
        value: 'source_state'
      },
      {
        text: 'Current State',
        align: 'center',
        sortable: false,
        value: 'state'
      }
    ]
  }),

  computed: {
    overtimeRequestActivities: get<Transition[]>(
      'overtimeRequest/getOvertimeRequestActivities'
    ),

    OvertimeRequest: () => OvertimeRequest
  },

  methods: {
    moment,

    ...mapActions({
      fetchOvertimeRequestActivities:
        'overtimeRequest/fetchOvertimeRequestActivities'
    }),

    clearAllErrors(): void {
      this.errorMessage = '';
      this.detailErrorMessage = '';
    },

    open(overtimeRequest: IOvertimeRequest) {
      this.clearAllErrors();

      this.request = overtimeRequest;

      this.dialog = true;
      this.loading = true;

      this.fetchOvertimeRequestActivities(overtimeRequest.id)
        .catch(error => {
          if (error.response) {
            if (error.response.data.detail) {
              this.detailErrorMessage = error.response.data.detail;
            }
          }
          this.errorMessage = ErrorManager.extractApiError(error);
        })
        .finally(() => {
          this.loading = false;
        });
    },

    close() {
      this.dialog = false;
    }
  }
});
